// @flow
/** @jsx h */

import { h, Component } from 'preact'

import styles from './AlternativeList.css'
import type { Alternative as AlternativeType } from '../../../../../types'
import { Alternative } from './components/Alternative'
import { bem } from '../../../../../helpers/bem'
import { breakpointToClassName } from '../../../../../helpers/breakpointToClassName'
import { getMaxLength } from '../../../../../helpers/get-text-max-length'

type Props = {
  children?: ?any,
  alternatives: any, // Array<AlternativeType>,
  onAlternativeClicked: (alternative: AlternativeType) => void
}

const MAX_SMALL_TEXT_LENGTH = 22

export class AlternativeList extends Component<Props> {
  render () {
    const { alternatives, onAlternativeClicked } = this.props
    const { currentBreakpoint } = this.context
    const alternativesItems = alternatives.list
      .reduce((acc, alternativeId) => {
        const alternative = alternatives[alternativeId]
        alternative.id = alternativeId
        acc.push(alternative)
        return acc
      }, [])

    const currentMaxTextLength = getMaxLength(alternativesItems, 'text')
    const fullWidthMobile = currentMaxTextLength > MAX_SMALL_TEXT_LENGTH
    const oddEven = alternatives.list.length % 2 !== 0 ? 'odd' : 'even'
    const two = alternatives.list.length === 2 ? 'two' : ''

    return (
      <div
        className={bem(
          styles.alternativeList,
          two || oddEven,
          breakpointToClassName(currentBreakpoint),
          fullWidthMobile ? 'full-width' : null
        )}
      >
        {alternativesItems.map((alternative, idx) => (
          <div
            key={alternative.id}
            className={bem(
              styles.alternativeList__item,
              fullWidthMobile ? 'full-width' : null
            )}
          >
            <Alternative
              onClick={onAlternativeClicked}
              alternative={alternative}
              isLastItem={isLastItem(idx, alternatives)}
              totalAlternativesCount={alternatives.length}
            />
          </div>
        ))}
      </div>
    )
  }
}

function isLastItem (index: number, alternatives: Array<AlternativeType>) {
  return index === alternatives.length - 1
}



// WEBPACK FOOTER //
// ./src/shared/widgets/LivePoll/components/LivePoll/AlternativeList/AlternativeList.js